<template>
  <div v-if="doc">
    <v-tabs dark>
      <v-tabs-slider></v-tabs-slider>

      <v-tab
        :href="`#tab-${index + 1}`"
        v-for="(tab, index) in doc.exercisesOrder"
        :key="tab.id"
        >{{ tab.title }}</v-tab
      >

      <v-tab-item
        :value="`tab-${index + 1}`"
        v-for="(tab, index) in doc.exercisesOrder"
        :key="tab.id"
      >
        <results-tiles :doc="doc" v-if="tab.slug == 'tiles'" />
        <results-functionality :doc="doc" v-if="tab.slug == 'functionality'" />
        <results-keywords :doc="doc" v-if="tab.slug == 'keywords'" />
        <results-messages :doc="doc" v-if="tab.slug == 'message'" />
        <results-proposition :doc="doc" v-if="tab.slug == 'proposition'" />
        <results-tov :doc="doc" v-if="tab.slug == 'tov'" />
        <results-swot :doc="doc" v-if="tab.slug == 'swot'" />
        <results-service :doc="doc" v-if="tab.slug == 'service'" />
        <results-fly :doc="doc" v-if="tab.slug == 'fly'" />
        <results-archetypes :doc="doc" v-if="tab.slug == 'archetypes'" />
        <results-personas :doc="doc" v-if="tab.slug == 'personas'" />
        <results-structure :doc="doc" v-if="tab.slug == 'structure'" />
        <results-architecture :doc="doc" v-if="tab.slug == 'architecture'" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  ResultsTiles,
  ResultsFunctionality,
  ResultsKeywords,
  ResultsMessages,
  ResultsProposition,
  ResultsTov,
  ResultsSwot,
  ResultsService,
  ResultsFly,
  ResultsArchetypes,
  ResultsPersonas,
  ResultsStructure,
  ResultsArchitecture
} from "@/components/results";

export default {
  name: "AdminProjectResults",
  data() {
    return {
      doc: null,
    };
  },
  components: {
    ResultsTiles,
    ResultsFunctionality,
    ResultsKeywords,
    ResultsMessages,
    ResultsProposition,
    ResultsTov,
    ResultsSwot,
    ResultsService,
    ResultsFly,
    ResultsArchetypes,
    ResultsPersonas,
    ResultsStructure,
    ResultsArchitecture
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss"></style>
